<template>
  <ul-page class="page-virtual-grade" contentWidthFixed>
    <template v-slot:left>
      <div class="page-header-left">
        <div class="page-header-title">实验成绩</div>
      </div>
    </template>
    <div class="page-content">
      <div class="filters">
        <ul-select class="select-teacher" v-if="userInfoInCourse.permissionGroupId == 1" v-model="params.teacherId" @change="currentTeacherChange">
          <ul-option
            v-for="item in teacherList"
            :key="item.userId"
            :label="item.name"
            :value="item.userId">
          </ul-option>
        </ul-select>
        <ul-select class="select-class" v-model="params.classId" :popper-append-to-body="false"  @change="getFirstPage">
          <ul-option
            v-for="item in teacherClassList"
            :key="item.classId"
            :label="item.className"
            :value="item.classId">
          </ul-option>
        </ul-select>
        <ul-input class="input-search"
          v-model="params.keyword"
          clearable
          suffix-icon="icon-quanshipei-sousuo"
          @keydown.native.enter="getFirstPage" 
          search
          @clear="getFirstPage"
          @search="getFirstPage"
          placeholder="输入姓名或学号搜索"
        ></ul-input>
      </div>
      <div class="tab-status">
        <div class="item" @click="getListByStatus(0)"><span class="label" :class="{active:params.status == 0}">全部</span><span class="count">{{(stat.totalNum || 0)}}</span></div>
        <div class="item" @click="getListByStatus(1)"><span class="label" :class="{active:params.status == 1}">已完成</span><span class="count">{{stat.completeNum || 0}}</span></div>
        <div class="item" @click="getListByStatus(2)"><span class="label" :class="{active:params.status == 2}">未完成</span><span class="count">{{stat.incompleteNum || 0}}</span></div>
      </div>
      <ul-table
        :data="gradeList"
        background
      >
      <ul-table-column
        prop="className"
        label="班级">
      </ul-table-column>
      <ul-table-column
        prop="userName"
        width="100px"
        label="姓名">
      </ul-table-column>
      <ul-table-column
        prop="studentId"
        width="120px"
        label="学号">
      </ul-table-column>
      <ul-table-column
        prop="status"
        width="80px"
        label="状态">
        <template slot-scope="scope">
          <span :class="{'secondary-text-color': scope.row.status !== 1}">{{scope.row.status == 1 ? '已完成': '未完成'}}</span>
        </template>
      </ul-table-column>
      <ul-table-column
        prop="joinTimes"
        width="68px"
        label="次数">
      </ul-table-column>
      <ul-table-column
        prop="startTime"
        width="148px"
        label="开始时间">
        <template slot-scope="scope">
          <span class="">{{scope.row.startTime | formatDate}}</span>
        </template>
      </ul-table-column>
      <ul-table-column
        prop="endTime"
        width="148px"
        label="结束时间">
        <template slot-scope="scope">
          <span class="">{{scope.row.endTime | formatDate}}</span>
        </template>
      </ul-table-column>
      <ul-table-column
        prop="timeUsed"
        width="100px"
        label="时长">
        <template slot-scope="scope">
          <div class="cell-timeUsed">
            <div>{{scope.row.timeUsed | duration}}</div>
          </div>
        </template>
      </ul-table-column>
      <ul-table-column
        prop="score"
        width="68px"
        label="成绩">
        <template slot-scope="scope">
          <div class="cell-timeUsed">
            <div>{{scope.row.score === undefined ? '--': scope.row.score}}</div>
          </div>
        </template>
      </ul-table-column>
      <ul-table-column
        class-name="col-operate"
        width="100px"
        label="操作">
        <template slot-scope="scope">
          <ul-dropdown
            @command="handleCommandexport($event, scope.row)"
            v-if="scope.row.joinTimes >= 1"
            class="export-stu"
          >
            <ul-button size="small" class="ul-dropdown-link">
              <span class="button-text">查看</span>
              <i class="iconfont icon-xialacaozuo"></i>
            </ul-button>
            <ul-dropdown-menu slot="dropdown" class="export-menu-stu">
              <ul-dropdown-item command="a">查看</ul-dropdown-item>
              <ul-dropdown-item command="b">重新评分</ul-dropdown-item>
            </ul-dropdown-menu>
          </ul-dropdown>
          <span v-else>--</span>
        </template>
      </ul-table-column>
      </ul-table>
      <ul-pagination
        hide-on-single-page
        layout="prev, pager, next"
        :total="totalNum"
        :page-size.sync="params.ps"
        :current-page.sync="params.pn"
        @current-change="getGradeList"
        ></ul-pagination>
      <ul-dialog
        title="实验步骤成绩详情"
        :visible.sync = "experimentDetailDialogVisible"
        :close-on-click-modal="false"
        width="940px"
      >
        <experimentDetail :stuId="stuId" v-if="experimentDetailDialogVisible"></experimentDetail>
      </ul-dialog>
    </div>

    <ul-dialog
      width="550px"
      title="重新评分"
      class="re-scoring"
      :visible.sync="dialogVisible"
    >
      <ul-form ref="scoringForm" :model="form" :rules="rules" label-width="80px">
        <ul-form-item label="得分" prop="newScore">
          <ul-input
            class="score-input"
            v-model="form.newScore"
            type="number"
          />
          <span class="hint">满分100分</span>
          <span>原始分数：{{ form.score }}分</span>
        </ul-form-item>
        <ul-form-item label="评语" prop="comment">
          <ul-input type="textarea" placeholder="请添加评语" :resize="'none'" v-model="form.comment" class="input"></ul-input>
        </ul-form-item>

      </ul-form>
      <span slot="footer" class="dialog-footer">
        <ul-button type="primary" @click="reScoring">确定</ul-button>
        <ul-button plain @click="dialogVisible = false">取消</ul-button>
      </span>
    </ul-dialog>
  </ul-page>
</template>

<script>
import { getUserOcRole, getOcTeacherClassList, getVirtualGradeList,experimentScoreDetails, experimentTeaMark } from '@/api/courseApi'
import { mapGetters } from 'vuex'
import { formatDate, formatSeconds } from '@/utils'
import experimentDetail from './experimentDetail.vue'
export default {
  name: 'page-virtual-grade',
  data () {
    return {
      experimentDetailDialogVisible: false,
      dialogVisible: false,
      userInfoInCourse: {},
      teacherList: [{
        userId: -1,
        name: "全部教师",
        classes: [{
          classId: -1,
          className: "全部班级",
        }]
      }],
      params: {
        teacherId: -1,
        classId: -1,
        keyword: '',
        status: 0,
        ps: 10,
        pn: 1
      },
      stat:{
        totalNum: 0,
        completeNum: 0,
        incompleteNum: 0
      },
      gradeList: [],
      stuId: '',
      rules: {
        newScore: [
          { required: true, message: '请输入分数', trigger:"blur" },
          { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '请输入0-100的整数', trigger: 'blur'},
        ],
        comment: [
          { min: 0, max: 500, message: '评语不能超过500字符', trigger: 'blur' },
        ]
      },
      form: {
        newScore: 0,
        comment: ""
      },
      formRow: {}
    }
  },
  computed: {
    ...mapGetters({ user: 'user/user' }),
    ocId () {
      return this.$route.query.ocId
    },
    experimentId () {
      return this.$route.query.experimentId
    },
    teacherClassList () {
      for (let i = 0; i < this.teacherList.length; i++) {
        const tea = this.teacherList[i];
        if (tea.userId == this.params.teacherId) {
          return tea.classes
        }
      }
      return []
    },
    totalNum () {
      if (this.params.status == 0) {
        return this.stat.totalNum
      }
      if (this.params.status == 1) {
        return this.stat.completeNum
      }
      if (this.params.status == 2) {
        return this.stat.incompleteNum
      }
    }
  },
  created () {
    window.test = this
    getUserOcRole(this.ocId)
      .then(result => {
        this.userInfoInCourse = result
        this.getTeacherList()
      })
  },  
  methods: {
    getScoreDetails() {
      experimentScoreDetails({recordId: this.formRow.recordId })
      .then(({result}) => {
        this.form = result
      })
    },
    reScoring() {
      this.$refs.scoringForm.validate((valid) => {
        if (valid) {
          experimentTeaMark({
            recordId: this.formRow.recordId,
            newScore: this.form.newScore,
            comment: this.form.comment || ""
          })
          .then(() => {
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.dialogVisible = false
            this.getGradeList()
          })
        }
      })
    },
    handleCommandexport(e, row) {
      console.log(e, row);
      if (e == 'a') {
        this.viewDetail(row)
      } else {
        this.formRow = JSON.parse(JSON.stringify(row))
        this.dialogVisible = true
        this.getScoreDetails()
        this.$nextTick(()=> {
          this.$refs.scoringForm.resetFields();
        })
      }
    },
    isClassInList (item,list) {
      for (let i = 0; i < list.length; i++) {
        const ele = list[i];
        if (item.classId == ele.classId) {
          return true
        }
      }
      return false
    },
    getTeacherList () {
      getOcTeacherClassList(this.ocId)
        .then((result) => {
          this.teacherList = []
          let allClassList = []
          result.list.forEach(item => {
            if (item.classes.length > 0) {
              this.teacherList.push(item)
              for (let i = 0; i < item.classes.length; i++) {
                const cl = item.classes[i]
                if (!this.isClassInList(cl, allClassList)) {
                  allClassList.push(cl)
                }
              }
            }
          })
          this.teacherList.unshift({
            userId: -1,
            name: "全部教师",
            classes: allClassList
          })
          this.teacherList.forEach(item => {
            item.classes.unshift({
              classId: -1,
              className: "全部班级",
            })
          })
           this.params.teacherId = this.userInfoInCourse.userId
            if (this.teacherClassList.length == 0) {
              this.params.teacherId = -1
            }
            this.currentTeacherChange()
        })
    },
    currentTeacherChange () {
      this.params.classId = -1
      this.params.pn = 1
      this.getGradeList()
    },
    getFirstPage () {
      this.params.pn = 1
      this.getGradeList()
    },
    getListByStatus (status) {
      
      this.params.status = status
      this.params.pn = 1
      this.getGradeList()
    },
    getGradeList () {
      let params = {...this.params}
      params.experimentId = this.experimentId
      params.ocId = this.ocId
      params.teacherId = params.teacherId === -1 ? undefined : params.teacherId
      params.classId = params.classId === -1 ? undefined : params.classId
      params.status = params.status || undefined
      getVirtualGradeList(params)
        .then(({result}) => {
          this.stat.totalNum = result.totalNum
          this.stat.incompleteNum = result.incompleteNum
          this.stat.completeNum = result.completeNum
          this.gradeList = result.list
        })
    },
    viewDetail (stu) {
      this.stuId = stu.userId
      this.experimentDetailDialogVisible = true
    }
  },
  filters: {
    duration (time) {
      return formatSeconds(time) || '--'
    },
    formatDate (time) {
      return formatDate(time) || '--'
    }
  },
  components: {
    experimentDetail
  }
}
</script>

<style lang="scss" scoped>
.page-content{
  margin-top: 24px;
  padding: 32px;
}
.page-title{
  padding-bottom: 20px;
  border-bottom: $--border-dashed;
  font-size: 16px;
  font-weight: 600;
}
.filters{
  .ul-select{
    margin-right: 10px;
  }
  .select-teacher{
    width: 110px;
  }
  .select-class{
    width: 180px;
  }
  .input-search{
    width: 200px;
  }
}
::v-deep.export-stu{
  .ul-dropdown-link {
    color: #ea5947;
    background: #fff;
    .button-text {
      display: inline-block;
      width: 46px;
      text-align: left;
    }
    .icon-xialacaozuo {
      font-size: 12px;
      transform: scale(0.7);
      display: inline-block;
    }
  }
}
::v-deep.re-scoring {
  .score-input {
    width: 110px;
  }
  .hint {
    color: #969696;
    margin: 0 20px 0 10px;
  }
  .input {
    width: 400px;
    textarea {
      height: 80px;
    }
  }
}
.tab-status{
  padding: 20px 0 12px;
  .item{
    margin-right: 20px;
    display: inline-block;
    cursor: pointer;
  }
  .label{
    font-weight: bold;
    &.active{
      color: $--color-primary;
    }
  }
  .count{
    color: $--color-text-secondary;
    margin-left: 4px;
  }
}
.ul-pagination{
  text-align: center;
  margin-top: 15px;
}
</style>